import { render, staticRenderFns } from "./SubmissionDetail.vue?vue&type=template&id=4614824c&scoped=true"
import script from "./SubmissionDetail.vue?vue&type=script&lang=js"
export * from "./SubmissionDetail.vue?vue&type=script&lang=js"
import style0 from "./SubmissionDetail.vue?vue&type=style&index=0&id=4614824c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.3.4_css-loader@6.8.1_webpack@5.88.2__lodash@4.17_2b05b4b7daaef4c710e484e85375d138/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4614824c",
  null
  
)

export default component.exports